import cn from 'classnames'
import { FC, useMemo } from 'react'

import { periods } from './configs'

import styles from './Period.module.scss'

interface IPeriodProps {
  period?: string
}

export const Period: FC<IPeriodProps> = ({ period }) => {
  const selectedPeriods = useMemo(() => {
    return period?.split(',') ?? []
  }, [period])

  return (
    <div className={styles.root}>
      {periods.map((it) => (
        <div
          key={it}
          className={cn(styles.periodItem, {
            [styles.periodItem__active]: selectedPeriods.includes(it),
          })}
        >
          {it}
        </div>
      ))}
    </div>
  )
}
